/**
 * Dispatch an event at the end of the execution queue
 * @param  {string} eventType – Event name
 */
export default function dispatchEvent(eventType) {
  setTimeout(() => {
    let event;
    if (typeof Event === 'function') {
      event = new Event(eventType);
    } else {
      event = document.createEvent('Event');
      event.initEvent(eventType, true, true);
    }
    window.dispatchEvent(event);
  });
}
